import { Component, Input, OnInit } from '@angular/core';
import {
    trigger,
    state,
    style,
    animate,
    transition,
} from '@angular/animations';

@Component({
    selector: 'cagov-content-panel',
    templateUrl: './content-panel.component.html',
    styleUrls: ['./content-panel.component.scss'],
    animations: [
        trigger('panelState', [
            state(
                'active',
                style({
                    opacity: 1,
                }),
            ),
            transition('void => *', [
                style({
                    opacity: 0,
                    transform: 'translateY(15px)',
                }),
                animate('500ms 300ms ease-out'),
            ]),
        ]),
    ],
    standalone: false,
})
export class CaGovContentPanelComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {
        this.isVisible = 'active';
    }

    @Input() noShadow: boolean = false;
    @Input() marginBottom: number = 0;
    isVisible: string = 'inactive';
}
